/*
 *公共方法 
 *ajax 
 *
 *
 */

import mock from "@/mock/mock";
const config = require('../../config')
import axios from 'axios'
import {
    BASE_CONFIG
} from '@/config/config'
import {
    SERVICE_CODE,
    STATE_CODE
} from '@/config/interface'
import CryptoJS from 'crypto-js';
import {Message} from 'element-ui';

let Common = {
    request(txCode, reqParams, callback, errorCallback, loadingStartCallback, loadingEndCallback) {

        // 模拟数据
        //if (config.dev.mockData) {
        //     callback(mock['MOCK' + txCode])
        //     return
        // }
        //判断是否有权限
        // let limitTxCode = sessionStorage.getItem('limitTxCode') || '';
        // if(limitTxCode.indexOf(txCode) > -1){
        //     Message.error('没有权限');
        //     window.location.href="#/noright";//跳转到错误页面
        //     return
        // }

        let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        let isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        let isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        let IE = false
        if(isIE || isEdge || isIE11) {
            IE = true  
        }else{
            IE = false  //不是ie浏览器
        }
        console.log(IE)
        if (typeof loadingStartCallback == 'function') {
            loadingStartCallback();
        }
        let self = this;
        let date = new Date();
        let seperator1 = "-";
        let seperator2 = ":";
        let month = (date.getMonth() + 1).toString();
        let strDate = (date.getDate()).toString();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        let currentdate = date.getFullYear() + month + strDate + date.getHours() + date.getMinutes() + date.getSeconds();


        let params = {
            txCode: txCode || '000000',
            deviceId: '',
            sessionId: '',
            custId: '',
            timestamp: currentdate || '',
            reqParams: reqParams || {}

        };

        // 加密
        let cryptoParams = JSON.stringify(params);
        cryptoParams = CryptoJS.enc.Utf8.parse(cryptoParams);

        let key = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
        let iv = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
        let encrypted = CryptoJS.AES.encrypt(cryptoParams, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC
        });

        let requestDone = false;

        let promise = axios({
            method: 'POST',
            url: BASE_CONFIG.SERVICE_ADDRESS,
            timeout: BASE_CONFIG.REQUEST_TIMEOUT,
            params: {
                jsonparams: BASE_CONFIG.CRYPTO_KEY_OPEN ? encrypted.toString() : params
            },
            withCredentials:true
        });
        promise.then(doneCallbacks, failCallbacks);

        function doneCallbacks(resp) {
            if (typeof loadingEndCallback == 'function') {
                loadingEndCallback();
            }
            requestDone = true;
            let data = resp.data;

            //缓存里更新最新的系统时间
            localStorage.setItem('systemTime',data.systemTime)

            if (data.respCode == STATE_CODE.CORRECT_CODE) {
                //typeof callback === 'function' && callback(data);

                if (STATE_CODE.ERROR_CODE.test(data.respData.respCode)) {
                    typeof errorCallback === 'function' && errorCallback(data);
                } else {
                    typeof callback === 'function' && callback(data);
                }
            } else {
                // 报错
                //Message.error('系统错误');

                if (STATE_CODE.ERROR_CODE.test(data.respCode)) {
                    
                    if(IE){
                        window.location.href="#/error";//跳转到错误页面
                        window.location.reload()
                    }else{
                        window.location.href="#/error";//跳转到错误页面
                    }
                    typeof errorCallback === 'function' && errorCallback(data);
                } else if (data.respCode == STATE_CODE.SESSION_TIMEOUT_CODE || data.respCode == STATE_CODE.HAS_LOGIN_CODE) {
                    //  登录异常 跳转到登录页
                    //
                    // if(IE){
                    //     window.location.href="#/login";
                    //     window.location.reload()
                    // }else{
                    //     window.location.href="#/login";
                    // }
                    typeof errorCallback === 'function' && errorCallback(data);
                } else if (data.respCode == STATE_CODE.RIGHT_LIMITE_CODE){
                    //  没有操作权限 跳转提示
                    if(IE){
                        Message.error('您的权限受限制');
                        window.location.href="#/noright";//跳转到错误页面
                        window.location.reload()
                    }else{
                        window.location.href="#/noright";//跳转到错误页面
                    }
                   
                    typeof errorCallback === 'function' && errorCallback(data); 
                } else {
                    
                    if(IE){
                        window.location.href="#/error";//跳转到错误页面
                        window.location.reload()
                    }else{
                        window.location.href="#/error";//跳转到错误页面
                    }
                    typeof errorCallback === 'function' && errorCallback(data);
                }
            }
        }

        function failCallbacks(resp) {
            // 报错
            //Message.error('连接失败');
            if(IE){
                window.location.href="#/error";//跳转到错误页面
                window.location.reload()
            }else{
                window.location.href="#/error";//跳转到错误页面
            }
            
            requestDone = true;
            if (typeof loadingEndCallback == 'function') {
                loadingEndCallback();
            }

            typeof errorCallback === 'function' && errorCallback();
        }
        setTimeout(function () {
            if (!requestDone) {
                if (typeof loadingEndCallback == 'function') {
                    loadingEndCallback();
                }
                //requestXhr.abort();
                //return promise.reject(error);
            }
        }, BASE_CONFIG.REQUEST_TIMEOUT);


    },
    requestUpLoad(txCode, reqParams, doRequest) {
        //console.log(reqParams)
        let self = this;
        let date = new Date();
        let seperator1 = "-";
        let seperator2 = ":";
        let month = (date.getMonth() + 1).toString();
        let strDate = (date.getDate()).toString();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        let currentdate = date.getFullYear() + month + strDate + date.getHours() + date.getMinutes() + date.getSeconds();


        let params = {
            txCode: txCode || '000000',
            deviceId: '',
            sessionId: '',
            custId: '',
            timestamp: currentdate || '',
            reqParams: reqParams || {}
        };

        // 加密
        let cryptoParams = JSON.stringify(params);
        cryptoParams = CryptoJS.enc.Utf8.parse(cryptoParams);

        let key = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
        let iv = CryptoJS.enc.Utf8.parse(BASE_CONFIG.CRYPTO_KEY);
        let encrypted = CryptoJS.AES.encrypt(cryptoParams, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC
        });

         let requestDone = false;
         //这种写法 发送请求 会报错
         axios({
             url:BASE_CONFIG.SERVICE_ADDRESS,
             method:'post',
             headers:{'Content-type': 'multipart/form-data'},
             params: {
                 jsonparams: BASE_CONFIG.CRYPTO_KEY_OPEN ? encrypted.toString() : params
             },
             data:reqParams ,//Qs.stringify(reqParams)
             withCredentials:true
         })
        .then(doneCallbacks,failCallbacks);


         function doneCallbacks(resp){

             requestDone = true;
             let data = resp.data;

             if (data.respCode == STATE_CODE.CORRECT_CODE) {
                 // 存储customID
                 data.custId && sessionStorage.setItem('customID', data.custId);
                 // 存储会话ID
                 data.sessionId && sessionStorage.setItem('sessionID', data.sessionId);

                 typeof callback === 'function' && callback(data);
             } else {
                if (STATE_CODE.ERROR_CODE.test(data.respCode)) {
                    window.location.href="#/error";//跳转到错误页面
                    typeof errorCallback === 'function' && errorCallback(data);
                } else if (data.respCode == STATE_CODE.SESSION_TIMEOUT_CODE || data.respCode == STATE_CODE.HAS_LOGIN_CODE) {
                    //  登录异常 跳转到登录页
                    // window.location.href="#/login";
                    typeof errorCallback === 'function' && errorCallback(data);
                } else if (data.respCode == STATE_CODE.RIGHT_LIMITE_CODE){
                    //  没有操作权限 跳转提示
                    window.location.href="#/noright";//跳转到错误页面
                    typeof errorCallback === 'function' && errorCallback(data); 
                } else {
                    window.location.href="#/error";//跳转到错误页面
                    typeof errorCallback === 'function' && errorCallback(data);
                }
             }
         }

         function failCallbacks(resp){
             requestDone = true;
             typeof errorCallback === 'function' && errorCallback();
             window.location.href="#/error";//跳转到错误页面
         }

    }
}

export {
    Common
};


// WEBPACK FOOTER //
// ./src/utils/http.js